import { Monitor } from '../types/status';
import MonitorItem from './MonitorItem';
import '../css/monitor-list.css';

interface MonitorListProps {
  monitors: Monitor[];
}

const MonitorList = ({ monitors }: MonitorListProps) => {
  return (
    <ul className="monitors">
      {monitors.map((monitor) => (
        <MonitorItem key={monitor.id} monitor={monitor} />
      ))}
    </ul>
  );
};

export default MonitorList;
